<template>
  <div class="baseContainter">
    <loadingSpan v-if='loading ' :loadZIndex='loadZIndex'></loadingSpan>
    <lk-affix>
      <div class="subHeader clear">
        <div class="breadcrumb">
          <lk-breadcrumb>
            <lk-breadcrumb-item v-for="item in breadcrumb" :key='item.name' :to="{name:item.name}">
              {{item.title}}
            </lk-breadcrumb-item>
          </lk-breadcrumb>
        </div>
        <div class="ctrls" v-if="btns.length || ctrls">
          <slot name="ctrls"></slot>
          <lk-button v-for="(btn,index) in btns" :type="btn.type || 'default'" :disabled="btn.disabled" :key="index" @click="onBtnClick(btn)">{{btn.text}}</lk-button>
        </div>
      </div>
      <div class="info" v-if="infos">
        <div>{{idText}}：{{infos.id}}</div>
        <div>
          <span>创建人：</span><span>{{infos.createUserName}}</span>
          <span class="padding-span">创建时间：</span><span>{{infos.createTime}}</span>
          <span class="padding-span">修改人：</span><span>{{ infos.modifiedUserName}}</span>
          <span class="padding-span">最后修改时间：</span><span>{{infos.modifiedTime}}</span>
        </div>
      </div>
      <!-- 一列布局的快捷方式 -->
      <div class="info" v-if="infosArr.length">
        <h4>{{infoTitle}}：{{infoContent}}</h4>
        <div v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </div>
      </div>
      <div class="info">
        <slot name="info"></slot>
      </div>

    </lk-affix>
    <div class="content">
      <slot name="content" ></slot>
    </div>

  </div>
</template>
<script>
import loadingSpan from '../LoadingSpan.vue';

export default {
  name: 'NewBaseFrame',
  components: {
    loadingSpan,
  },
  props: {
    infos: {
      type: Object,
    },
    btns: {
      type: Array,
      default() {
        return [
          // {
          //   name: 'submit',
          //   text: '提交',
          //   type: 'primary'
          // },
        ];
      },
    },
    ctrls: {
      type: Boolean,
      default: false,
    },
    loadZIndex: { // loadingSpan组件层级
      type: Boolean,
      default: false,
    },
    infoTitle: {
      type: String,
      default: '',
    },
    infoContent: {
      type: String,
      default: '',
    },
    infosArr: {
      type: Array,
      default: () => [],
    },
    breadcrumb: {
      type: Array,
      default() {
        return [
          // {
          //   name: 'plan',
          //   title: '采购计划列表'
          // },
          // {
          //   name: 'planAdd',
          //   title: '新增采购计划'
          // }
        ];
      },
    },
  },
  computed: {
    loading() {
      return this.$store.state.app.loading;
    },
  },
  methods: {
    onBtnClick(btn) {
      this.$emit('btn-click', btn.name);
    },
  },
};
</script>
<style lang="less" scoped>
.baseContainter{
  .subHeader{
    padding-left: 24px;
    padding-right: 32px;
    padding-top: 8px;
    padding-bottom: 1.5px;
    // line-height: 1;
    background: #fff;
    // display: flex;
    // justify-content: space-between;
    line-height: 32px;
    .ctrls{
      float: right;
      display: flex;
    }
    .ctrls>*{
      margin-left: 16px
    }
    .breadcrumb{
      float: left;
    }
  }
  .content{
    // background: #fff;
    padding: 16px;
    padding-top: 12px;
    // padding-bottom: 56px
    position: relative;
  }
  .info{
    background: #fff;
    padding:0 32px 20px 24px;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    padding-bottom: 12px;
  }
  // .info div:first-child{
  //   color: rgba(0,0,0,0.75);
  // }
}
.padding-span{
  padding-right:15px;
}
</style>
